import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import httpClient from "../../utils/httpClient";

export const getGaragesAsync = createAsyncThunk(
  "garages/getGaragesAsync",
  async (data, {rejectWithValue}) => {
    try{
      const response = await httpClient.get(`/garage/${data.id}`);
      if(response.status != 200) {
        throw new Error('Garage retrieval failed.');
      }
      return {
        id: data.id,
        data: response.data,
        success: response.status == 200 ? true : false,
        status: response.status
      };
    } catch(e) {
      return rejectWithValue({
        message: e.response?.data?.errors?.[0],
      });
    }
  } 
);

const garagesSlice = createSlice({
    name: "garages",
    initialState: {
      allGarages: [],
      filteredGarages: [],
      loading: false,
    },
    reducers: {
      setGarages: (state,action) => {
        console.log('PAYLOAD', action.payload);
        state.allGarages = action.payload;
        state.filteredGarages = action.payload.filter(g => g.networkName == 'AA SUPPLIER NETWORK');
      },
      filterGarages: (state, action) => {
        if(action.payload) {
          state.filteredGarages = state.allGarages.filter(g => g.networkName == 'AA SUPPLIER NETWORK');
        }
        if(!action.payload) {

          state.filteredGarages = state.allGarages.filter(g => g.networkName != 'AA SUPPLIER NETWORK');
        }
      }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getGaragesAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
              })
              .addCase(getGaragesAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                const response = action.payload;
                if(response.success) {
                  state.allGarages = response.data;
                  state.filteredGarages = response.data.filter(g => g.networkName == 'AA SUPPLIER NETWORK');
                }
              })
              .addCase(getGaragesAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message || 'Update suspend failed.';
                return state;
              })
    }
});

export const { setGarages, filterGarages } = garagesSlice.actions;
export default garagesSlice.reducer;